<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <span>
        برند
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe1 div_panding'
                [ngClass]="{width100:type_task == 3}">
                <label for="title" class='wh-label'>
                    <span> عنوان </span>
                    <input class="wh-input" formControlName="title" [required]="required()">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe1 div_panding'
                [ngClass]="{width100:type_task == 3}">
                <label for="title2" class='wh-label'>
                    <span> عنوان انگلیسی </span>
                    <input class="wh-input" formControlName="title2" [required]="required()">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe1 div_panding'
                [ngClass]="{width100:type_task == 3}">
                <label for="status_id" class='wh-label'>
                    <span> وضعیت نمایش </span>
                    <span (click)="reset_input(26)">
                        <mat-icon class="close" class="input_search input_search_pe">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title" (click)="load_services(26) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>
        </div>
        <div class="row pe1" [hidden]="type_task == 3">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe padding0">

                <span>دستگاههای مربوط به این برند را انتخاب کنید :</span>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe padding0" *ngFor="let x of list_device">
                <label class="wh-label">
                    <mat-checkbox class="pe1" name="device[]" value="{{ x.wharehouse_device_id }}"
                        (change)="select_items()" [checked]="x.checked">
                        <span>{{ x.wharehouse_device_title }}</span>
                    </mat-checkbox>
                </label>
            </div>
        </div>
        <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe mt-2' style="padding-right: 10px;">
            <div class='wh-label logo_title mb-1'>عکس برند </div>
            <div class='wh-label logo_title mb-2 text-muted'>سایز پیشنهادی : عرض 828 پیکسل ارتفاع 448 پیکسل</div>

            <div *ngIf="logo_loading == true" class="upload_div_loading">
                <div class="spinner-border spinner-border-sm upload_spinner-border-sm" role="status">
                    <span class="visually-hidden"></span>
                </div>
            </div>
            <a (click)="open_logo()" class="cursor">
                <div class="upload_div_file" *ngIf="logo_type == 'pdf' && logo_loading == false">
                    <i class="far fa-file-pdf upload_div_file_icon" style="color: red;"></i>
                </div>
                <mat-card class="example-card logo cursor backgroundImage upload_div_file2"
                    *ngIf="logo_type != 'pdf' && logo_loading == false"
                    [ngStyle]="{'background-image':'url( ' + logo + ')'}" accept="image/*">
                    <mat-card-header style="display:inline" class="pe1">
                    </mat-card-header>
                </mat-card>
            </a>
            <span (click)="delete_logo()" *ngIf="logo_bin == true">
                <button type="button" style="width: 110px;margin-right: 10px;" class="btn upload_button_change mt-2">حذف
                    فایل</button>
            </span>
            <div class="upload_image_change cursor" (click)="logo3.click()">
                <button type="button" style="width: 110px;" class="btn upload_button_change mt-2">آپلود فایل</button>
            </div>
            <input type="file" (change)="change_logo($event)" style="display: none;" #logo3
                accept="image/*,application/pdf">
        </div>
    </div>

    <div mat-dialog-actions align="start" class="pe1 matDialogActions" style="padding-right:25px">
        <button type="submit" class="btn_pe" [disabled]="!form1_group.valid || loading" *ngIf="type_task != 3">
            {{ messageService.get_event_title(type_task) }}
        </button>
        <button type="submit" class="btn_pe" *ngIf="type_task == 3">
            {{ messageService.get_event_title(type_task) }}
        </button>
    </div>
</form>